import { MIN_SEARCH_STRING_LENGTH } from '../../constants/search';

export const isValidSearchString = (value: string) =>
  value && value.trim() && value.trim().length >= MIN_SEARCH_STRING_LENGTH;
